import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';

import { PaymentsConfigRule } from 'src/models/payments-config.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentsConfigService {

  private http = inject(HttpClient);

  async getPaymentsConfig(): Promise<PaymentsConfigRule[]> {
    return firstValueFrom(
      this.http.get<PaymentsConfigRule[]>(`${environment.api_url}api/v1/customer/payments-config`)
    );
  }

  async createPaymentsConfigRule(rule: Partial<PaymentsConfigRule>): Promise<PaymentsConfigRule> {
    return firstValueFrom(
      this.http.post<PaymentsConfigRule>(`${environment.api_url}api/v1/customer/payments-config`, rule)
    );
  }

  async updatePaymentsConfigRule(id: number, rule: Partial<PaymentsConfigRule>): Promise<PaymentsConfigRule> {
    return firstValueFrom(
      this.http.put<PaymentsConfigRule>(`${environment.api_url}api/v1/customer/payments-config/${id}`, rule)
    );
  }

  async deletePaymentsConfigRule(id: number): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(`${environment.api_url}api/v1/customer/payments-config/${id}`)
    );
  }
}
